import {LayerEsriMapServer, makeServiceUrl, localCacheUrl} from 'webmapsjs/dist/layers/LayerEsriMapServer';
import LayerSwipe from 'webmapsjs/dist/olHelpers/layerSwipe';
import {getState, iState} from './store';
import {valsMetrics, valsTimePeriod} from './constants';
import Map from 'ol/Map';

let minZoomCached = 4;
let maxZoomCached = 8;

export let all_layers: LayerEsriMapServer[] = [];

interface iLayerKeys1 {
    [s: string]: LayerEsriMapServer[]
}

interface iLayerKeys2 {
    [s: string]: iLayerKeys1
}

// let layerKeysInterstate: iLayerKeys2 = {};
// let layerKeysOther: iLayerKeys2 = {};

let layerDiv;
let theUl;
let lis;

export function setLegend(state: iState): boolean {

    if (!layerDiv) {
        layerDiv = document.querySelector('.legend-layer-div');
    }

    if (!layerDiv) {
        return false
    }

    if (!theUl) {
        theUl = layerDiv.querySelector('ul');
    }

    if (!theUl || theUl.children.length == 0) {
        return false;
    }

    lis = theUl.children;

    for (let i = 0; i < lis.length; i++) {
        switch (state.metric) {
            case valsMetrics[0]:
                if (i == 0) {
                    lis[i].classList.remove('suppress-legend')
                } else {
                    lis[i].classList.add('suppress-legend')
                }
                break;

            case valsMetrics[1]:
                if (i == 1) {
                    lis[i].classList.remove('suppress-legend')
                } else {
                    lis[i].classList.add('suppress-legend')
                }
                break;
            case valsMetrics[2]:

                let theIndex = valsTimePeriod.indexOf(state.period) + 2;

                if (i == theIndex) {
                    lis[i].classList.remove('suppress-legend')
                } else {
                    lis[i].classList.add('suppress-legend')
                }
                break;
            default:
                throw 'val not found';
        }
    }

    return true;
}


export function setVisibleLayers() {
    let state = getState();

    for (let l of all_layers) {
        l.visible = false;
    }

    // if (state.showInterstate) {
    //     for (let lyr of layerKeysInterstate[state.metric][state.period]) {
    //         lyr.visible = true;
    //     }
    // }

    // if (state.showOther) {
    //     for (let lyr of layerKeysOther[state.metric][state.period]) {
    //         lyr.visible = true;
    //     }
    // }

    if (!setLegend(state)) {
        let int = setInterval(() => {
            if (setLegend(state)) {
                clearInterval(int)
            }
        }, 100)
    }
}


//
// export function addLayers(map: Map, swiper: LayerSwipe) {
//
//     let mpaOpacity = 1;
//     let mpaLayers = [0, 1];
//
//     let cachedMpa = new LayerEsriMapServer(
//         localCacheUrl('NPMRDS', 'mpa_bounds'),
//         {
//             minZoom: minZoomCached,
//             maxZoom: maxZoomCached,
//             showLayers: mpaLayers,
//             visible: true,
//             name: 'mpa_cache',
//             getLegend: false,
//             opacity: mpaOpacity
//         });
//
//     let dynamicMpa = new LayerEsriMapServer(
//         makeServiceUrl('NPMRDS', 'mpa_bounds'),
//         {
//             minZoom: maxZoomCached + 1,
//             showLayers: mpaLayers,
//             visible: true,
//             name: name + 'mpa_dyn',
//             getLegend: false,
//             opacity: mpaOpacity
//         });
//
//     map.addLayer(cachedMpa.olLayer);
//     map.addLayer(dynamicMpa.olLayer);
//
//     for (let i = 0; i < 144; i++) {
//
//         let isInterstate = Math.floor(i / 18) % 2 == 0;
//         let metric = valsMetrics[Math.floor(i / 6) % 3];
//         let timePeriod = valsTimePeriod[i % 6];
//         let year = (2017 + Math.floor(i / 36)).toFixed();
//
//         let _name = `${year}-${isInterstate ? 'int' : 'non_int'}-${metric}-${timePeriod}-`;
//
//         let cached = new LayerEsriMapServer(
//             localCacheUrl('NPMRDS', 'compare_2017_2018'),
//             {
//                 minZoom: minZoomCached,
//                 maxZoom: maxZoomCached,
//                 showLayers: [i],
//                 visible: i == 0,
//                 name: _name + 'cache',
//                 getLegend: false,
//                 zIndex: isInterstate ? 7 : 5
//             });
//
//         let dynamic = new LayerEsriMapServer(
//             makeServiceUrl('NPMRDS', 'compare_2017_2018'),
//             {
//                 minZoom: maxZoomCached + 1,
//                 showLayers: [i],
//                 visible: i == 0,
//                 name: _name + 'dyn',
//                 getLegend: false,
//                 zIndex: isInterstate ? 7 : 5
//             });
//
//         // if (i < 36) {
//         //     swiper.addLeftLayer(cached);
//         //     swiper.addLeftLayer(dynamic);
//         // } else {
//         //     swiper.addRightLayer(cached);
//         //     swiper.addRightLayer(dynamic);
//         // }
//
//         // if (i >= 18 && i <= 23) {
//         //     //temporarily don't add
//         // } else {
//         //
//         // }
//
//         map.addLayer(cached.olLayer);
//         map.addLayer(dynamic.olLayer);
//
//         all_layers.push(cached);
//         all_layers.push(dynamic);
//
//         if (isInterstate) {
//             if (!layerKeysInterstate[metric]) {
//                 layerKeysInterstate[metric] = {}
//             }
//
//             if (!layerKeysInterstate[metric][timePeriod]) {
//                 layerKeysInterstate[metric][timePeriod] = [];
//             }
//
//             layerKeysInterstate[metric][timePeriod].push(cached);
//             layerKeysInterstate[metric][timePeriod].push(dynamic);
//         } else {
//             if (!layerKeysOther[metric]) {
//                 layerKeysOther[metric] = {}
//             }
//
//             if (!layerKeysOther[metric][timePeriod]) {
//                 layerKeysOther[metric][timePeriod] = [];
//             }
//
//             layerKeysOther[metric][timePeriod].push(cached);
//             layerKeysOther[metric][timePeriod].push(dynamic);
//         }
//     }
//
//     setVisibleLayers();
// }
